<template>
  <div class="py-4 container-fluid">
    <div class="row" v-if="currentPoint">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Punto {{ currentPoint.name }}</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'Puntos' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card">
              <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div>
                  <label class="form-control-label">
                    Nombre
                  </label>
                  <p>{{ currentPoint.name }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Experiencia
                  </label>
                  <p>{{ currentPoint.experience.name }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Tipo
                  </label>
                  <p>{{ currentPoint.type.name }}</p>
                </div>
              </div>
                <div class="col-md-6">
                <div>
                  <label class="form-control-label">
                    Descripción
                  </label>
                  <p> {{ currentPoint.description }}</p>
                </div>
                <div>
                  <label  class="form-control-label">
                    Latitud
                  </label>
                  <p> {{ currentPoint.latitude }}</p>
                </div>
                <div>
                  <label  class="form-control-label">
                    Longitude
                  </label>
                  <p> {{ currentPoint.longitude }}</p>
                </div>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


     const route = useRoute();
     const store = useStore();

    const getCurrentPoint = async (id) => {
      return await store.dispatch("point/getPointById", id);
    };

    const currentPoint = computed(() => store.state.point.currentPoint);

    onMounted(()=> {
      getCurrentPoint(route.params.id)
    });


</script>
